export const SET_MODULES_DATA = 'SET_MODULES_DATA';

export function setModules(data) {
	return dispatch => {
		dispatch({
			type: SET_MODULES_DATA,
			data,
		});
	};
}